import { getAction, listAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";
import { Article } from "../classes/article.class";
import { Exhibition } from "../classes/exhibition.class";


/**
 * Gets a center entry.
 */
export const getArticleEntry = function (value, slugOrId, recursive) {
    return getAction('posts', value, slugOrId, recursive).then(data => {
        if(data.data[0])
            return processEntry(data.data[0]);
        if(data.data)
            return processEntry(data.data);
    });
}

/**
 * Gets a list of centers.
 */
export const getNewsList = function (recursive, page, perPage) {
    return listAction('posts', recursive, page, perPage).then(data => {
        return { content: processList(data.data), totalNews: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
    });
}

/**
 * Process data.
 */
const processData = function (data) {
    let content = data.data;
    return content;
}

/**
 * Process Entry.
 */
const processEntry = function (data) {

    let content = new Article(data);
    
    if (content.image)
        content.image = new Image(data.related_ids[content.image[0]]);
    
    if (content.gallery.length) {
        content.gallery = content.gallery.map(image => {
            if (data.related_ids[image])
                return new Image(data.related_ids[image]);
        });
    }

    if (content.exhibitions) {
        content.exhibitions = content.exhibitions.map(item => {
            if (data.related_ids[item])
                return new Exhibition(data.related_ids[item])
        });
    }
    return content;
}

/**
 * Process List.
 */
const processList = function (data) {
    let content = data;

    content = content.map(value => {
        return processEntry(value)
    })

    return content;
}


// WEBPACK FOOTER //
// ./src/data/models/article.model.js